import { useState } from "react";
import PropTypes from "prop-types";
import dayjs from "dayjs";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  Flex,
  Label,
  Button,
  FormGroup,
  ModalBody,
  TextInput,
  ModalFooter,
  ModalHeader,
  ModalPortal,
  ModalContent,
  DateTimePicker,
  ModalContainer,
} from "@ubisend/pulse-components";

import { createLicense as createLicenseApi } from "../api";

const CreateLicense = ({ account_id, project_id, handleCancel }) => {
  const [license, setLicense] = useState({
    project_id,
    account_id,
    start: dayjs().toDate(),
    end: "",
    set_to_expire: false,
  });

  const queryClient = useQueryClient();

  const handleChangeStart = ([date]) => setLicense({ ...license, start: date });
  const handleChangeEnd = ([date]) => setLicense({ ...license, end: date });

  const { mutate: createLicense } = useMutation({
    mutationFn: createLicenseApi,
    onSuccess: () => {
      handleCancel(false);
      queryClient.invalidateQueries({
        queryKey: [`licenses/${license.project_id}`],
      });
    },
  });

  const handleSubmit = (event) => {
    event.preventDefault();

    createLicense({
      project_id: license.project_id,
      account_id: license.account_id,
      start: license.start,
      end: license.end,
    });
  };

  return (
    <ModalPortal>
      <form onSubmit={handleSubmit}>
        <ModalContainer>
          <ModalContent>
            <ModalHeader>Create a new license</ModalHeader>
            <ModalBody>
              <FormGroup>
                <Label>License valid from</Label>
                <DateTimePicker
                  date={license.start}
                  onChange={handleChangeStart}
                />
              </FormGroup>
              <FormGroup>
                <Label>License expires on</Label>
                {!license.set_to_expire && (
                  <Flex xSpace>
                    <TextInput disabled value="Never Expire" />
                    <Button
                      onClick={() =>
                        setLicense({
                          ...license,
                          set_to_expire: true,
                          end: dayjs().add(1, "year").toDate(),
                        })
                      }
                    >
                      Change
                    </Button>
                  </Flex>
                )}
                {license.set_to_expire && (
                  <DateTimePicker
                    date={license.end}
                    onChange={handleChangeEnd}
                  />
                )}
              </FormGroup>
            </ModalBody>
            <ModalFooter>
              <Flex xSpace>
                <Button onClick={handleCancel} variant="secondary">
                  Cancel
                </Button>
                <Button type="submit">Save</Button>
              </Flex>
            </ModalFooter>
          </ModalContent>
        </ModalContainer>
      </form>
    </ModalPortal>
  );
};

CreateLicense.propTypes = {
  project: PropTypes.any,
  submit: PropTypes.func,
  handleCancel: PropTypes.func,
};

export default CreateLicense;
